var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpenOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5442 10.4398C32.2947 11.4215 32.2947 12.7468 31.5442 13.7268C29.1803 16.8128 23.5088 23.1667 16.8873 23.1667C10.2658 23.1667 4.59427 16.8128 2.23035 13.7268C1.86521 13.2568 1.66699 12.6785 1.66699 12.0833C1.66699 11.4881 1.86521 10.9099 2.23035 10.4398C4.59427 7.35392 10.2658 1 16.8873 1C23.5088 1 29.1803 7.35392 31.5442 10.4398V10.4398Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8877 16.8333C19.511 16.8333 21.6377 14.7067 21.6377 12.0833C21.6377 9.45996 19.511 7.33331 16.8877 7.33331C14.2643 7.33331 12.1377 9.45996 12.1377 12.0833C12.1377 14.7067 14.2643 16.8333 16.8877 16.8333Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenOutline);
export default __webpack_public_path__ + "static/media/eyeOpenOutline.b49a6ef478605d870937715475f636b6.svg";
export { ForwardRef as ReactComponent };